import React from 'react';
import PropTypes from 'prop-types';
import Button from '../ui/button';
import Text from '../ui/Text';

const CourseLinkButton = ({ path, description }) => {
  return (
    <>
      {description ? (
        <Text fontSize="lg" mb="24px" align="justify">
          {description}
        </Text>
      ) : null}
      <Button to={path} target="_blank" fullwidth>
        Conheça nosso curso preparatório
      </Button>
    </>
  );
};

CourseLinkButton.propTypes = {
  path: PropTypes.string.isRequired,
  description: PropTypes.string,
};

CourseLinkButton.defaultProps = {
  description: null,
};

export default CourseLinkButton;
